<template>
  <div class="sign-in">
    <my-modal>
      <form class="form" @submit.prevent="submit">
        <h2 class="form__title">
          Добро пожаловать<br> на mevius.ru
        </h2>
        <div class="form-row form-row_no-flex">
          <text-input
            label="Телефон*"
            type="tel"
            v-model="$v.form.login.$model"
            name="login"
            :error="$v.form.login.$error"
          >
            <template #errors>
              <div class="text-input__error" v-if="$v.form.login.$error">
                <div v-if="!$v.form.login.required">Обязательное поле</div>
                <div v-if="!$v.form.login.phone">Неверный формат телефона</div>
              </div>
            </template>
          </text-input>
        </div>
        <div class="form-row form-row_no-flex">
          <text-input
            label="Пароль*"
            type="password"
            name="password"
            v-model="$v.form.password.$model"
            :error="$v.form.password.$error"
          >
            <template #errors>
              <div class="text-input__error" v-if="$v.form.password.$error">
                <div v-if="!$v.form.password.required">Обязательное поле</div>
              </div>
            </template>
          </text-input>
        </div>
        <div class="form-row form-row_no-flex">
          <div class="form-row form-row_mobile-no-flex">
            <check-input
              label="Чужой компьютер"
              name="not-my-device"
              v-model="$v.form.dontRemember.$model"
            />
            <router-link :to="{ name: 'reset' }" class="form__link">Восстановить пароль</router-link>
          </div>
        </div>
        <smart-captcha ref="smartCaptcha" v-model="$v.form.captcha.$model">
          <template #errors>
            <div class="text-input__error">
              <div v-if="$v.form.captcha.$error">Необходимо пройти капчу</div>
            </div>
          </template>
        </smart-captcha>
        <div class="form__error-alert" v-show="hasError">
          Пожалуйста, проверьте правильность заполнения формы
        </div>
        <div class="sign-in__footer">
          <button class="sign-in__submit button button__lg button__blue" type="submit">Войти</button>
          <router-link :to="{name: 'register'}" class="form__link">Зарегистрироваться</router-link>
          <router-link :to="{ name: 'feedback' }" class="form__link">Написать нам</router-link>
        </div>
      </form>
    </my-modal>
  </div>
</template>

<script>
import {helpers, required} from "vuelidate/lib/validators";
import MyModal from './MyModal';
import CheckInput from "./CheckInput";
import TextInput from "./TextInput";
// import { parseQueryString, MyError } from "../utils"
import SmartCaptcha from "./SmartCaptcha.vue";
import api from "../services/api";
import SmartCaptchaMixin from "../mixins/smartCaptchaMixin";

const phoneRegex = helpers.regex('val1', /^(\+)?(\(\d{2,3}\) ?\d|\d)(([ -]?\d)|( ?\(\d{2,3}\) ?)){5,12}\d$/);

export default {
  name: "SignIn",
  mixins: [SmartCaptchaMixin],
  components: {
    SmartCaptcha,
    MyModal,
    CheckInput,
    TextInput,
  },
  data() {
    return {
      hasError: false,
      form: {
        login: '',
        password: '',
        dontRemember: false,
        captcha: '',
      }
    };
  },
  validations() {
    const form = {
      login: {
        required,
        phone: phoneRegex
      },
      password: {required},
      captcha: {required},
      dontRemember: {},
    }
    return { form };
  },
  methods: {
    async submit() {
      await this.refreshCaptcha()

      this.$v.form.$touch();
      this.hasError = this.$v.form.$invalid;

      if (!this.$v.form.$pending && !this.$v.form.$invalid) {
        this.$store.dispatch('showLoader');

        try {
          const result = await this.$store.dispatch('login', this.form);
          if (result) {
            // отобразить в личном кабинете вкладку "Документы", если пользователь в сегменте "Отображать паспорт в ЛК"
            const userSegments = await this.$store.dispatch('fetchUserSegments');
            const needPassport = userSegments?.needPassport;
            this.$store.dispatch(
              'setShowDocumentsTab',
              needPassport === true ||
              (typeof needPassport === 'string' && needPassport.trim().length > 0)
            );

            const next = this.$route.query.next;

            if (next) {
              return this.$router.push({path: next.toString()});
            }

            await this.$store.dispatch('hideErrorsBag');

            if (result?.stepRegistration) {
              await this.$store.dispatch('segmentsJump', result?.stepRegistration);
            } else {
              this.$router.push({path: '/'});
            }
          }
        } catch (e) {
          await this.$store.dispatch('setErrors', e);
          await this.updateCaptchaOnError();
        } finally {
          await this.$store.dispatch('hideLoader');
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import "../scss/base/_settings.scss";
.sign-in {
  &__submit {
    margin: 30px auto;
    min-width: 155px;
    @include mobile {
      width: 100%;
      margin: 20px auto;
    }
  }

  &__footer {
    display: flex;
    flex-direction: column;
    align-items: center;

    .form__link:not(:last-child) {
      margin-bottom: 6px;
    }
  }

  .my-modal__content {
    width: 100%;
    max-width: 470px;

    .form-captcha {
      gap: 16px;

      @include mobile {
        flex-direction: column;
      }

      .text-input {
        width: 130px;

        @include mobile {
          width: 100%;
        }
      }

      &__image {
        flex: 1 1 auto;

        @include mobile {
          justify-content: flex-start;
          width: 100%;
        }
      }
    }
  }
}
</style>
